// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Ni7QE","content":"styles_content__FI7lF","subtitle":"styles_subtitle__IxKWD"};